module.exports = __webpack_public_path__ + "img/help-white.9e074197.svg";